/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  version: '1.4.0',
}

const getters = {
  version: state => {
    return state.version
  },
}
const actions = {

}
const mutations = {

}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
